import { UAParser } from 'ua-parser-js';

import { buildH5CommonParams } from '@/utils/fetch/build-common-params';

import { tracker } from './dual-tracker';

function getBrowserFromUserAgent(): string {
    if (typeof navigator === 'undefined') {
        return '';
    }
    try {
        const { name, version } = new UAParser(navigator.userAgent).getResult().browser;
        const n = name?.trim() ?? '';
        const v = version?.trim() ?? '';
        if (!n) {
            return '';
        }
        return v ? `${n} ${v}` : n;
    } catch {
        return '';
    }
}

/**
 * 写入公共埋点字段到内存并在 device_id + user_id 就绪后放行采集（flush 队列 + QT START + 火山 start）。
 * 须在 head BLOCK 之后调用；tracker.start() 幂等。
 */
export const registerTrackerParams = async (params: Record<string, unknown>) => {
    const commonParams = await buildH5CommonParams();
    const deviceId = commonParams.device_id;

    tracker.setUserProfile({
        ...params,
        device_id: deviceId,
        os: commonParams.os_name,
        os_version: commonParams.os_version,
        browser: getBrowserFromUserAgent(),
        language: commonParams.language,
        timezone: commonParams.time_zone,
        country: '',
    });

    const userId = params.user_id;
    if (userId != null && userId !== '') {
        tracker.setUser({ userId: String(userId) });
    }

    if (deviceId && userId) {
        tracker.start();
    }
};

/**
 * 复访：三级存储已有 device_id 时尽早 setUserProfile + START，无需等 establishSession。
 * @returns 是否已放行采集
 */
export async function tryStartTrackerFromCachedDevice(): Promise<boolean> {
    const commonParams = await buildH5CommonParams();
    if (!commonParams.device_id) {
        return false;
    }
    await registerTrackerParams({});
    return true;
}
